import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React, { Fragment, useState, useRef, useCallback, useMemo, useEffect, useImperativeHandle } from 'react';
import isDefinedAndNotNull from '@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null';
import isFunction from '@userzoomlibraries/toolkit-js-utils/is-function';
import { I as InputGeneric } from './index.styled7.js';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import { IconButton } from '@userzoomlibraries/toolkit-button';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import { n as noPreview, p as preview } from './index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { T as TYPES, j as PASSWORD_PROP_TYPES, k as PASSWORD_DEFAULT_PROPS } from './index.styled8.js';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var EyeSuffix$1 = function EyeSuffix(_ref) {
  var className = _ref.className,
      isVisible = _ref.isVisible,
      onClick = _ref.onClick;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [isVisible && /*#__PURE__*/jsx(IconButton, {
      className: className,
      name: "no-preview",
      fallback: noPreview,
      onClick: onClick
    }), !isVisible && /*#__PURE__*/jsx(IconButton, {
      className: className,
      name: "preview",
      fallback: preview,
      onClick: onClick
    })]
  });
};

EyeSuffix$1.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  onClick: PropTypes.func
};
EyeSuffix$1.defaultProps = {
  className: '',
  isVisible: false,
  onClick: noop
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var EyeSuffix = styled(EyeSuffix$1).withConfig({
  componentId: "gz-input-1679042055220__sc-13s9deg-0"
})(["background-color:transparent;border:none;height:24px;width:24px;&:not(:disabled){.gz-icon-button__icon{path{fill:#000;}line:first-of-type{stroke:#000;}}&:focus-visible,&:focus,&:hover{background-color:transparent;border:none;.gz-icon-button__icon{path{fill:#314fff;}line:first-of-type{stroke:#314fff;}}}}"]);

var _excluded = ["autoComplete", "prefix", "suffix", "visibility", "onChange", "onChangeVisibility"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var InputPassword$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      visibility = _ref.visibility,
      onChange = _ref.onChange,
      onChangeVisibility = _ref.onChangeVisibility,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(visibility),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = useState(function () {
    return otherProps.defaultValue || otherProps.value || '';
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      internalState = _useState4[0],
      setInternalState = _useState4[1];

  var inputPasswordRef = useRef();
  var inputInnerRef = useRef();
  var calculateRefs = useCallback(function (node) {
    if (node) {
      inputPasswordRef.current = node;
      var inputInner = inputPasswordRef.current.querySelector('.gz-input');
      inputInnerRef.current = inputInner;
    }
  }, []);
  var visibilityHandler = useCallback(function () {
    var newVisibility = !isVisible;
    setIsVisible(newVisibility);
    inputInnerRef.current.focus();
    onChangeVisibility({
      visibility: newVisibility
    });
  }, [isVisible, onChangeVisibility]);
  var onChangeHandler = useCallback(function (_ref2) {
    var event = _ref2.event,
        newValue = _ref2.value;
    setInternalState(newValue);
    onChange({
      event: event,
      value: newValue
    });
  }, [onChange]);
  var prefixToProcess = useMemo(function () {
    if (isFunction(prefix)) {
      return prefix;
    }

    if (isDefinedAndNotNull(prefix)) {
      return function () {
        return prefix;
      };
    }

    return function () {
      return null;
    };
  }, [prefix]);
  var suffixToProcess = useMemo(function () {
    if (isFunction(suffix)) {
      return suffix;
    }

    if (isDefinedAndNotNull(suffix)) {
      return function () {
        return suffix;
      };
    }

    return function () {
      return /*#__PURE__*/jsx(EyeSuffix, {
        isVisible: isVisible,
        onClick: visibilityHandler
      });
    };
  }, [suffix, isVisible, visibilityHandler]);
  var autoCompleteToProcess = useMemo(function () {
    if (isDefinedAndNotNull(autoComplete)) {
      return autoComplete;
    }

    if (isVisible) {
      return 'off';
    }

    return 'current-password';
  }, [autoComplete, isVisible]);
  useEffect(function () {
    setIsVisible(visibility);
  }, [visibility]);
  useImperativeHandle(ref, function () {
    return inputPasswordRef.current;
  });
  return /*#__PURE__*/jsx(InputGeneric, _objectSpread(_objectSpread({
    ref: calculateRefs
  }, otherProps), {}, {
    type: isVisible ? TYPES.TEXT : TYPES.PASSWORD,
    "aria-placeholder": otherProps.placeholder,
    autoComplete: autoCompleteToProcess,
    onChange: onChangeHandler,
    prefix: prefixToProcess({
      disabled: otherProps.disabled,
      invalid: otherProps.invalid,
      value: internalState,
      changeVisibility: visibilityHandler
    }),
    suffix: suffixToProcess({
      disabled: otherProps.disabled,
      invalid: otherProps.invalid,
      value: internalState,
      changeVisibility: visibilityHandler
    })
  }));
});
InputPassword$1.COMPONENT_ID = 'Gearz.Input.Password';
InputPassword$1.displayName = InputPassword$1.COMPONENT_ID;
InputPassword$1.propTypes = _objectSpread({}, PASSWORD_PROP_TYPES);
InputPassword$1.defaultProps = _objectSpread({}, PASSWORD_DEFAULT_PROPS);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var InputPassword = styled(InputPassword$1).withConfig({
  componentId: "gz-input-1679042055220__sc-fwop6g-0"
})(["background-color:#fff;border:1px solid #000;border-radius:4px;box-sizing:border-box;display:flex;line-height:20px;margin:0px;min-width:0;position:relative;width:100%;&:not(:focus-within){&:not([aria-disabled=\"true\"]){&[aria-invalid=\"true\"]{border-color:#f00314;&:focus,&:focus-visible,&:hover{border-color:#474b6d;}}}}", ""], function (props) {
  return getThemeByProps({
    componentId: InputPassword$1.COMPONENT_ID,
    props: props
  });
});
InputPassword.displayName = InputPassword$1.displayName;
InputPassword.propTypes = InputPassword$1.propTypes;
InputPassword.defaultProps = InputPassword$1.defaultProps;

export { InputPassword as I };
